export const dashboardRoute = {
  path: '',
  loadChildren: () => import('../../components/dashboard/dashboard.module').then(m => m.DashboardModule)
};
export const deliveryAgentsRoute = {
  path: '',
  loadChildren: () => import('../../components/delivery-agent/delivery-agents.module').then(m => m.DeliveryAgentsModule)
};
export const userRolesRoute = {
  path: '',
  loadChildren: () => import('../../components/user-roles/user-roles.module').then(m => m.UserRolesModule)
};
export const businessRoute = {
  path: '',
  loadChildren: () => import('../../components/business/business.module').then(m => m.BusinessModule)
};
export const inventoryRoute = {
  path: '',
  loadChildren: () => import('../../components/inventory/inventory.module').then(m => m.InventoryModule)
};
export const ordersRoute = {
  path: '',
  loadChildren: () => import('../../components/orders/orders.module').then(m => m.OrdersModule)
};
export const quotationRequestRoute = {
  path: '',
  loadChildren: () => import('../../components/quotation-requests/quotation-requests.module').then(m => m.QuotationRequestsModule)
};
export const pickupOrdersRoute = {
  path: '',
  loadChildren: () => import('../../components/pickup-orders/pickup-orders.module').then(m => m.PickupOrdersModule)
};
export const notificationsRoute = {
  path: '',
  loadChildren: () => import('../../components/notifications/notifications.module').then(m => m.NotificationsModule)
};
export const invoicesRoute = {
  path: '',
  loadChildren: () => import('../../components/invoices/invoices.module').then(m => m.InvoicesModule)
};
export const contentRoute = {
  path: '',
  loadChildren: () => import('../../components/content/content.module').then(m => m.ContentModule)
};
export const ticketsRoute = {
  path: '',
  loadChildren: () => import('../../components/tickets/tickets.module').then(m => m.TicketsModule)
};
export const settingsRoute = {
  path: '',
  loadChildren: () => import('../../components/settings/settings.module').then(m => m.SettingsModule)
};
export const categoryRoute = {
  path: '',
  loadChildren: () => import('../../components/category/category.module').then(m => m.CategoryModule)
};